import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';

const AppContent = () => {
  const { lang } = useLanguage();

  return (
    <div className="min-h-screen bg-white font-sans selection:bg-[#c16e5e]/20 selection:text-[#c16e5e] flex flex-col">
      <Helmet>
        <title>Psykolog Kay Elizabeth Worsfold | Klinisk psykolog i København</title>
        <meta name="description" content="Autoriseret klinisk psykolog i København med 20+ års erfaring. Terapi, compassion fokuseret coaching og supervision på dansk og engelsk." />
        <html lang={lang} />
      </Helmet>
      
      <Header />
      <ScrollToTop />
      
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-mig" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/ressourcer" element={<Resources />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/privatlivspolitik" element={<Privacy />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
